import React from 'react';
import { history, } from '../store';

import MobileHeaderSidenav from './Layout/Header/MobileHeader'
import Header from './Layout/Header';

import '../../public/css/media.scss';
import '../../public/css/media/_footer.scss';
import '../../public/css/media/_sidebar.scss';
import '../../public/css/media/_not-found.scss';
import Footer from './Layout/Footer/Footer';

import { gtmPush } from '../utils/analyticsEvents';

const createReactClass = require('create-react-class');
const Main = createReactClass({

  getInitialState: () => {
    return {
      isHome: true,
      isSideNavOpen: false,
      cmsList: [],
      loading: true,
      footerLinks: ["2", "3", "4", "7",],
      bottomNavLinks: ["1", "5", "6",],
      bottomNavLinksClass: ["first about pull-left", "second terms pull-left", "third privacy pull-left",],
    }
  },
  componentWillMount() {
    this.props.location.pathname !== "/home" && this.props.location.pathname !== "/" ? this.setState({ isHome: false, }) : this.setState({ isHome: true, })
    this.props.getCMSList();
    this.props.getCopyrightYear();
    gtmPush({
      event: 'view',
      platform: 'web',
    });

  },
  componentWillReceiveProps(nextProps) {
    window.scrollTo(0, 0);
    if (this.props.location.pathname !== nextProps.location.pathname) {
      if (nextProps.location.pathname === "/home" || nextProps.location.pathname === "/") {
        this.setState({ isHome: true, });
      }
      else {
        this.setState({ isHome: false, });
      }
    }
    this.setState({
      cmsList: nextProps.cms.getCmsList ? nextProps.cms.CmsList.data : [],
    });
    if (nextProps.cms.getHomePageFetching) {
      this.setState({ loading: true, });
    }
    if (nextProps.cms.getHomePage) {
      this.setState({ loading: false, });
    }
    if (nextProps.cms.getMainBannerListFetching) {
      this.setState({ loading: true, });
    }
    if (nextProps.cms.getMainBannerList) {
      this.setState({ loading: false, });
    }
    if (nextProps.cms.fetching) {
      this.setState({ loading: true, });
    }
    // HAM : 404 page and shipping-estimates should show the footer
    if (nextProps.cms.getCms || nextProps.cms.CmsContent === null) {
      this.setState({ loading: false, });
    }
    if (nextProps.location.pathname === "/home" || nextProps.location.pathname === "/") {
      this.setState({ loading: true, }, () => { nextProps.cms.getHomePage ? this.setState({ loading: false, }) : this.setState({ loading: true, }) });
    }
  },
  componentDidUpdate() {
    if (this.props.login.error) {
      if (this.props.login.error.response && this.props.login.error.response.data.status === 401) {
        history.push("/signin");
      }
      if (this.props.login.error && this.props.login.error.data && this.props.login.error.data.status === 401) {
        history.push("/signin");
      }
    }
  },
  handleTrackPackage() {
    localStorage.setItem("trackPackage", "true");
  },
  render() {
    return (
      < div className={this.state.isHome ? "home index" : "home"} >
        {window.location.pathname !== '/otp-service' ?
          <div>
            <MobileHeaderSidenav
              isAuthenticated={this.props.auth.isAuthenticated}
              login={this.props.login}
              isSideNavOpen={this.state.isSideNavOpen}
              logout={this.props.logout}
            />
            <Header
              isAuthenticated={this.props.auth.isAuthenticated}
              login={this.props.login}
              logout={this.props.logout}
            />
          </div>
        : null
        }
        {React.cloneElement({ ...this.props, }.children, { ...this.props, })}
        <Footer
          currentPath={this.props.location.pathname}
          currentYear={this.props.login.year}
        />
      </div >
    )
  },
});
export default Main;



/** WEBPACK FOOTER **
 ** ./src/components/Main.js
 **/